/**
 * One row of a Home card: a soft-tinted icon, a title, a muted second line and
 * a chevron, the whole row a link. Shared by "Waiting on you" and "Pick up
 * where you left off".
 */

import type { ReactNode } from "react";
import { NavLink, ThemeIcon } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";
import { Link as RouterLink } from "react-router-dom";

export function HomeRow({
  to,
  icon,
  color,
  title,
  detail,
}: {
  to: string;
  icon: ReactNode;
  color: string;
  title: string;
  detail: string;
}) {
  return (
    <NavLink
      component={RouterLink}
      to={to}
      py="sm"
      px="xs"
      style={{ borderRadius: "var(--mantine-radius-md)" }}
      leftSection={
        <ThemeIcon variant="light" color={color} size={36} radius="md">
          {icon}
        </ThemeIcon>
      }
      label={title}
      description={detail}
      rightSection={<IconChevronRight size={16} />}
      styles={{
        label: { fontWeight: 500, fontSize: "var(--mantine-font-size-sm)" },
        description: { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
        body: { minWidth: 0 },
      }}
    />
  );
}
